import { DEFAULT_LAYOUT } from '../base';
import type { AppRouteRecordRaw } from '../types';

const BOARD: AppRouteRecordRaw = {
  path: '/board',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '看板管理',
    requiresAuth: true,
    icon: 'icon-dashboard',
    order: 40
  },
  children: [
    {
      path: 'list',
      component: () => {
        return import('@/views/dashboard/list/page.vue');
      },
      meta: {
        locale: '看板首页',
        icon: 'icon-nav',
        ignoreCache: true
      }
    }
  ]
};

export default BOARD;
